// DEPRECATED: Mock analytics service. All components now query Supabase directly.
// Kept only for ComparativeAnalytics and ExportReports which still use mock data.

import {
  BenchmarkComparison,
  Achievement,
  RecommendationItem,
} from './types';

class AnalyticsService {
  async fetchBenchmarks(): Promise<BenchmarkComparison[]> {
    await new Promise((resolve) => setTimeout(resolve, 450));
    return [
      { metric: 'Activities per Week', yourValue: 8.5, regionalAvg: 6.2, nationalAvg: 5.8, top10Avg: 12.3, unit: 'activities' },
      { metric: 'Photo Uploads', yourValue: 15, regionalAvg: 11, nationalAvg: 9, top10Avg: 22, unit: 'photos' },
      { metric: 'Score', yourValue: 745, regionalAvg: 620, nationalAvg: 580, top10Avg: 850, unit: 'points' },
      { metric: 'Network Engagement', yourValue: 7.8, regionalAvg: 6.1, nationalAvg: 5.5, top10Avg: 9.2, unit: 'score' },
      { metric: 'Response Time', yourValue: 4.2, regionalAvg: 6.5, nationalAvg: 7.8, top10Avg: 2.1, unit: 'hours' },
    ];
  }

  async fetchAchievements(): Promise<Achievement[]> {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return [
      { id: '1', name: 'First Steps', description: 'Complete your first activity', icon: 'trophy', unlockedAt: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), category: 'activity' as const },
      { id: '2', name: 'Photo Pro', description: 'Upload 100 photos', icon: 'camera', unlockedAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), category: 'activity' as const },
      { id: '3', name: 'Network Builder', description: 'Connect with 50 farmers', icon: 'users', progress: 75, category: 'network' as const },
      { id: '4', name: 'Gold Status', description: 'Reach Gold rank', icon: 'star', unlockedAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), category: 'score' as const },
    ];
  }

  async fetchRecommendations(): Promise<RecommendationItem[]> {
    await new Promise((resolve) => setTimeout(resolve, 350));
    return [
      { id: '1', title: 'Increase Network Engagement', description: 'Participate more in discussions.', priority: 'high', impact: '+25 points', action: 'Post or comment 3 times this week', category: 'network' },
      { id: '2', title: 'Maintain Photo Consistency', description: 'Keep up your photo upload streak.', priority: 'medium', impact: 'Preserve +180 points', action: 'Continue weekly photo uploads', category: 'photo' },
      { id: '3', title: 'Document Harvesting', description: 'More harvest documentation improves credibility.', priority: 'medium', impact: '+15 points', action: 'Log next harvest with photos', category: 'harvest' },
    ];
  }
}

export const analyticsService = new AnalyticsService();
